import React, { Component } from 'react'
import { MuiGrid, MuiTypography, MuiTextField, MuiButton, MuiToolTip } from '../../../../../ui/MaterialUIComponents'
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as StringReplacer from '../../../../../../i18n/StringReplacer'
import { DialogComponentUtil } from '..';
import theme from '../../../../../../assests/theme'
import spinner from "../../../../../ui/icons/spinner.gif";
export class RequiredSharedRoomComponent extends Component {
	render() {
		const { i18n } = this.props
		return (
			<React.Fragment>
				<MuiGrid container>
					<MuiToolTip
						placement="top-start"
						title={StringReplacer.getFormatedMessage(i18n.requiredSharedRoom.heading,
							{
								Subject: DialogComponentUtil.getSubjectsForTemplate(this.props),
								Grades: DialogComponentUtil.getToolTipString(this.props),
							})
						} >
						<MuiTypography style={theme.typography.h6} gutterBottom>
							{StringReplacer.getFormatedMessage(i18n.requiredSharedRoom.heading,
								{
									Subject: DialogComponentUtil.getSubjectsForTemplate(this.props),
									Grades: DialogComponentUtil.getGradeForTemplate(this.props),
								})
							}
						</MuiTypography>
					</MuiToolTip>
				</MuiGrid>

				<MuiGrid container xs={10} >
					<MuiGrid container xs={12}
						style={theme.tableHeaderStyle} justify="center"
					>
						<MuiTypography style={theme.tableHeaderTextStyle}>
							Available Rooms
            </MuiTypography>
					</MuiGrid>
					<MuiGrid container style={theme.gridTableSelectStyle}>
						<Autocomplete
							id="combo-box-demo"
							multiple
							defaultValue={this.props.sharedRoomsForSubject.room}
							options={this.props.school_sharedRooms}
							getOptionLabel={option => option.name}
							style={{ width: 500 }}
							onChange={(event, value) => { this.props.handleChangeName('name', event, value) }}
							renderInput={params => (
								<MuiTextField
									{...params}
									fullWidth
									InputProps={{ ...params.InputProps, disableUnderline: true }}
								/>)}
						/>
					</MuiGrid>

					{/* buttons  */}
				</MuiGrid>
				<MuiGrid container xs={12} justify="flex-end" style={{ marginTop: "10px", paddingTop: "10px", borderTop: "1px solid " + theme.palette.grey.main }}>

					<MuiGrid item style={{ marginRight: "10px" }}>
						<MuiButton style={theme.secondaryButtonStyle} onClick={this.props.handleCloseForDialog}>
							{i18n.commonTexts.cancel}
						</MuiButton>
					</MuiGrid>

					<MuiGrid item>
						{this.props.updateSchoolinformationInProgress ? <img src={spinner} alt="none" style={theme.spinnerImgStyleForButton} /> :
							<MuiButton disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle} onClick={() => this.props.onClickOfSave()}>
								{i18n.commonTexts.apply}
							</MuiButton>}
					</MuiGrid>
				</MuiGrid>
			</React.Fragment>
		)
	}
}
export default RequiredSharedRoomComponent
